import React from "react";
import ProjectCard from "./ProjectCard";

export default function Portfolio({ projectList }) {
  return (
    <section
      id="projects"
      className="relative bg-[#0F2419] text-[#F1E9D8] px-6 md:px-10 py-32 grain"
    >
      <div className="pointer-events-none absolute top-1/4 left-1/2 -translate-x-1/2 w-[26rem] h-[26rem] rounded-full bg-[#D4AF6A] opacity-[0.07] blur-[130px]" />

      <div className="max-w-5xl mx-auto relative">
        <div className="flex items-center justify-center gap-4 mb-16">
          <span className="text-sm text-[#D4AF6A]">05</span>
          <span className="w-10 h-px bg-[#D4AF6A]/40" />
          <h2 className="font-display text-4xl md:text-5xl font-light">
            Projects
          </h2>
          <span className="w-10 h-px bg-[#D4AF6A]/40" />
          <span className="text-sm text-[#D4AF6A]">05</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {projectList.map((project, index) => (
            <ProjectCard
              key={index}
              index={index}
              title={project.title}
              keywords={project.keywords}
              description={project.description}
              startDate={project.startDate}
              endDate={project.endDate}
              link={project.link}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
